export default __webpack_public_path__ + "static/3-d9aabad8098467a418907732641ddb85.jpeg";